const boot = () => {

  const sectionQuery = '.splider[data-pf-type*="Section"]';
  const sliderQuery = 'div[data-pf-type*="Slider"]';
  const carouselQuery = 'div[data-pf-type*="Carousel"]:not([data-slide-clone="true"])';

  const vSections = [];
  const sections = document.querySelectorAll(sectionQuery);

  sections.forEach((section) => {
    const vSliders = [];
    const sliders = section.querySelectorAll(sliderQuery);

    sliders.forEach((slider) => {
      const sliderAttribute = slider.getAttribute('data-sliderx');
      if(sliderAttribute) {
        const sliderConfig = sliderAttribute.replace(/'/g,'"');
        const config = JSON.parse(sliderConfig);
        const vSlides = [];
        const slides = slider.querySelectorAll(carouselQuery);

        slides.forEach((slide) => {
          const li = document.createElement("li");
          li.classList.add("splide__slide");
          li.innerHTML = slide.innerHTML;
          vSlides.push(li);

        });

        if(vSlides.length) {
          const ul = document.createElement("ul");
          ul.classList.add("splide__list");

          vSlides.forEach((li) => {
            ul.appendChild(li);
          });

          vSliders.push({ul, config, slider});
        }
      }
    });

    if(vSliders.length) {
      vSliders.forEach(({ul, config, slider}) => {
        const track = document.createElement("div");
        track.classList.add("splide__track");
        track.appendChild(ul);
        vSections.push({slider, track, config});
      });
    }
  });

  if(vSections.length) {
    vSections.forEach(({slider, track, config}) => {
      const column = slider.parentNode;
      column.removeChild(slider);
      //See docs https://splidejs.com/options/
      const options = {
        type: "loop",
        drag: true,
        arrows: config && config.navStyle !== 'none',
        pagination: config && config.paginationStyle !== 'none',
        autoplay: config ? !!config.autoPlay : false,
        interval: config ? config.autoPlayDelay : 5000,
        perPage: config && config.slidesToShow ? config.slidesToShow.all : 3,
        perMove: config && config.slidesToScroll ? config.slidesToScroll.all : 1,
        breakpoints: {
          640: {
            perPage: config && config.slidesToShow ? config.slidesToShow.mobile : 1,
            perMove: config && config.slidesToScroll ? config.slidesToScroll.mobile : 1,
          },
        }
      }

      const splide = document.createElement("div");
      splide.classList.add("splide");
      splide.setAttribute('id', 'splide');
      splide.setAttribute('data-splide', JSON.stringify(options));
      splide.appendChild(track);
      column.appendChild(splide);
    });
  }
};


boot();

document.querySelectorAll('.splide').forEach(splide => {
  new Splide( splide).mount();
});